/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_WorkingInputs */

const en_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work in progress. Please wait...`)
};

const fr_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement en cours. Veuillez patienter...`)
};

const de_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Arbeiten laufen. Bitte warten Sie...`)
};

const it_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavori in corso. Attendi...`)
};

const ru_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Работа продолжается. Пожалуйста, подождите...`)
};

const es_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo en progreso. Por favor, espere...`)
};

const zh_cn2_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在处理中，请稍候……`)
};

const ja_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業中です。しばらくお待ちください...`)
};

const hi_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`काम जारी है। कृपया प्रतीक्षा करें...`)
};

const pt_pt2_options_api_keys_working = /** @type {(inputs: Options_Api_Keys_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho em andamento. Aguarde...`)
};

/**
* | output |
* | --- |
* | "Work in progress. Please wait..." |
*
* @param {Options_Api_Keys_WorkingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_working = /** @type {((inputs?: Options_Api_Keys_WorkingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_WorkingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_working(inputs)
	if (locale === "de") return de_options_api_keys_working(inputs)
	if (locale === "it") return it_options_api_keys_working(inputs)
	if (locale === "ru") return ru_options_api_keys_working(inputs)
	if (locale === "es") return es_options_api_keys_working(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_working(inputs)
	if (locale === "ja") return ja_options_api_keys_working(inputs)
	if (locale === "hi") return hi_options_api_keys_working(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_working(inputs)
	return en_options_api_keys_working(inputs)
});